import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

// Create a new remixer
export const createRemixer = createAsyncThunk(
  "remixers/createRemixer",
  async ({ token, payload }) => {
    const response = await api.post("/remixers", { ...payload }, { token });
    return response.data;
  }
);

// Get all remixers with optional query parameters
export const getAllRemixers = createAsyncThunk(
  "remixers/getAllRemixers",
  async ({ token, ...queryParams }) => {
    const response = await api.get("/remixers", {
      token,
      params: queryParams,
    });
    return response.data;
  }
);

// Update an existing remixer
export const updateRemixer = createAsyncThunk(
  "remixers/updateRemixer",
  async ({ token, id, payload }) => {
    const response = await api.patch(
      `/remixers/${id}`,
      { ...payload },
      { token }
    );
    return response.data;
  }
);

// Delete a remixer by ID
export const deleteRemixer = createAsyncThunk(
  "remixers/deleteRemixer",
  async ({ token, id }) => {
    const response = await api.delete(`/remixers/${id}`, { token });
    return response.data;
  }
);

// Get a remixer by ID
export const getRemixerById = createAsyncThunk(
  "remixers/getRemixerById",
  async ({ token, id }) => {
    const response = await api.get(`/remixer/${id}`, { token });
    return response.data;
  }
);
